module.exports = once;